import { create } from 'zustand';
import {
  BigNumbersType,
  Filter,
  FilterData,
  ChainResponse,
  SectionResponse,
  CoverageParams,
  CoverageSectionParams,
  UfResponse,
  CategoryResponse,
  CityResponse,
} from './types';

type State = {
  bigNumbersData: BigNumbersType;
  coberturaRedeData: ChainResponse;
  coberturaRedeParams: CoverageParams;
  sectionCoverageData: SectionResponse;
  sectionCoverageParams: CoverageSectionParams;
  section: FilterData;
  ufCoverageData: UfResponse;
  ufCoverageParams: CoverageSectionParams;
  uf: FilterData;
  categoryCoverageData: CategoryResponse;
  categoryCoverageParams: CoverageSectionParams;
  category: FilterData;
  cityCoverageData: CityResponse;
  cityCoverageParams: CoverageSectionParams;
  city: FilterData;
};

type Actions = {
  setCoverageAnalysisState: (name: string, data: any) => void;
  reset: () => void;
};

export const coverageInitialState: State = {
  bigNumbersData: {} as BigNumbersType,
  coberturaRedeData: {} as ChainResponse,
  coberturaRedeParams: {
    diasAnalise: 90,
    page: 0,
    size: 10,
    query: '',
  } as CoverageParams,
  sectionCoverageData: {} as SectionResponse,
  sectionCoverageParams: {
    diasAnalise: 90,
    page: 0,
    size: 10,
    query: '',
    filtro: [] as string[],
  } as CoverageSectionParams,
  section: { list: [] as Filter[], value: [], cache: [] as Filter[] },
  ufCoverageData: {} as UfResponse,
  ufCoverageParams: {
    diasAnalise: 90,
    page: 0,
    size: 10,
    query: '',
    filtro: [] as string[],
  } as CoverageSectionParams,
  uf: { list: [] as Filter[], value: [], cache: [] as Filter[] },
  categoryCoverageData: {} as CategoryResponse,
  categoryCoverageParams: {
    diasAnalise: 90,
    page: 0,
    size: 10,
    query: '',
    filtro: [] as string[],
  } as CoverageSectionParams,
  category: { list: [] as Filter[], value: [], cache: [] as Filter[] },
  cityCoverageData: {} as CityResponse,
  cityCoverageParams: {
    diasAnalise: 90,
    page: 0,
    size: 10,
    query: '',
    filtro: [] as string[],
  } as CoverageSectionParams,
  city: { list: [] as Filter[], value: [], cache: [] as Filter[] },
};

export const useAnaliseCoberturaStore = create<State & Actions>(set => ({
  ...coverageInitialState,
  setCoverageAnalysisState: (name, data) => {
    set(() => ({
      [name]: data,
    }));
  },
  reset: () => {
    set(coverageInitialState);
  },
}));
